var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "merchant-overview" },
    [
      _vm._m(0),
      !_vm.statsData
        ? _c(
            "div",
            { staticClass: "dashboard-skeleton-list" },
            _vm._l(3, function (n) {
              return _c(
                "div",
                { key: n, staticClass: "dashboard-skeleton-item" },
                [
                  _c(
                    "a-row",
                    { attrs: { gutter: 12 } },
                    [
                      _c(
                        "a-col",
                        {
                          staticClass: "dashboard-skeleton-item-col",
                          attrs: { span: 8 },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "dashboard-skeleton-item-col-content",
                            },
                            [
                              _c("a-skeleton", {
                                attrs: { active: "", title: false },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "a-col",
                        {
                          staticClass: "dashboard-skeleton-item-col",
                          attrs: { span: 8 },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "dashboard-skeleton-item-col-content",
                            },
                            [
                              _c("a-skeleton", {
                                attrs: { active: "", title: false },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "a-col",
                        {
                          staticClass: "dashboard-skeleton-item-col",
                          attrs: { span: 8 },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "dashboard-skeleton-item-col-content",
                            },
                            [
                              _c("a-skeleton", {
                                attrs: { active: "", title: false },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            0
          )
        : _c("jeepay-card", {
            key: _vm.cardKey,
            attrs: {
              span: { xxl: 3, xl: 3, lg: 3, md: 2, sm: 2, xs: 1 },
              height: 120,
              "add-authority": false,
              "req-card-list-func": _vm.getStatsList,
            },
            scopedSlots: _vm._u([
              {
                key: "cardContentSlot",
                fn: function ({ record }) {
                  return [
                    _c("div", { staticClass: "dashboard-stat-card" }, [
                      _c(
                        "div",
                        { staticClass: "card-tag", class: record.tagClass },
                        [_vm._v(" " + _vm._s(record.tag) + " ")]
                      ),
                      _c("div", { staticClass: "main-data" }, [
                        _c("div", { staticClass: "main-value" }, [
                          _vm._v(
                            _vm._s(_vm.formatValue(record.value, record.type))
                          ),
                        ]),
                        _c("div", { staticClass: "main-title" }, [
                          _vm._v(_vm._s(record.title)),
                        ]),
                      ]),
                      _c("div", { staticClass: "sub-data" }, [
                        _c("span", { staticClass: "sub-label" }, [
                          _vm._v(_vm._s(record.subTitle)),
                        ]),
                        _c("span", { staticClass: "sub-value" }, [
                          _vm._v(_vm._s(record.subValue)),
                        ]),
                      ]),
                    ]),
                  ]
                },
              },
            ]),
          }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "justify-content": "space-between",
          "align-items": "center",
        },
      },
      [_c("h2", { staticClass: "section-title" }, [_vm._v("商户概览")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }